// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"4b5af702","281":"4de691f6","634":"aef853eb","671":"c16b6b95","938":"f87ee688"}[chunkId] + ".chunk.css";
};